export const GameListColumns = [
  { header: 'Game Title', columnDef: 'title' },
  { header: 'Created Date', columnDef: 'created_at' },
  { header: 'Themes', columnDef: 'game_theme' },
  { header: 'Scheduled', columnDef: 'scheduled_date' },
  { header: 'none', columnDef: 'actions' },
];
